export default __webpack_public_path__ + "static/logo-963f0fbcb9603950f659fab0fdb30455.svg";